export default "__VITE_ASSET__BLpe5Cc6__"